import React, { useState } from "react";
import { connect } from "react-redux";
import { Map } from "immutable";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import * as actions from "MODULES/PurchaseOrders/actions";
import {
  BUYER,
  CO_BUYER,
  CO_BUYER_ID,
  FULL_NAME,
  THIRD_BUYER,
  THIRD_BUYER_ID,
  USER
} from "MODULES/users/constants";
import { ID, SHIPPING_TYPE } from "APP_ROOT/constants";
import Form from "../Form";

function AddPart({
  open,
  close,
  paid,
  onSubmit,
  part,
  id,
  purchaseOrder,
  currentUser
}) {
  const initialValues = {
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    evaluation_period: 30,
    reserve_for_seller_id: currentUser.get(ID),
    read_only_buyer: purchaseOrder.getIn([BUYER, FULL_NAME]),
    insurance_type: "None",
    cancelled: false,
    cost: paid ? "0" : undefined,
    purchase_for_sale: false,
    purchase_for_stock: false,
    purchase_for_repair: false,
    purchase_for_repair_assist: false,
    buyer_credit_pct: 75
  };

  const lineItem = part && { part, part_id: part.id };
  const [selectedPart, setSelectedPart] = useState({});
  const domLifeYears = get(selectedPart, "dom_life_years");
  const llp = get(selectedPart, "llp");

  if (!purchaseOrder.get("buyers_discrepancy")) {
    initialValues.buyer_credit_pct = purchaseOrder.get("buyer_credit_pct");
    initialValues.co_buyer_id = purchaseOrder.get(CO_BUYER_ID);
    initialValues.third_buyer_id = purchaseOrder.get(THIRD_BUYER_ID);
    if (lineItem) {
      lineItem.co_buyer =
        purchaseOrder.get(CO_BUYER) && purchaseOrder.get(CO_BUYER).toJS();
      lineItem.third_buyer =
        purchaseOrder.get(THIRD_BUYER) && purchaseOrder.get(THIRD_BUYER).toJS();
    }
  }

  return (
    <Modal open={open} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Add a Part</h4>
      </Header>
      <Form
        close={close}
        displaySrpInventoryTable
        initialValues={initialValues}
        selectedPart={selectedPart}
        setSelectedPart={setSelectedPart}
        domLifeYears={domLifeYears}
        llp={llp}
        lineItem={lineItem}
        paid={paid}
        id={id}
        shippingType={purchaseOrder.get(SHIPPING_TYPE)}
        onSubmit={onSubmit}
      />
    </Modal>
  );
}

export default connect(
  state => ({
    purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder"),
    currentUser: state.session.get(USER)
  }),
  dispatch => ({
    onSubmit: data => dispatch(actions.addLineItem(data))
  })
)(AddPart);

AddPart.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  id: PropTypes.number,
  part: PropTypes.instanceOf(Object),
  purchaseOrder: PropTypes.instanceOf(Map),
  currentUser: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/LineItemsTable/AddPart/AddPart.jsx